import { Component, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { DocumentService } from '@app/services/document.service';
import { SidebarService } from '@services/sidebar.service';

@Component({
  selector: 'app-document-view-users',
  templateUrl: './document-view-users.component.html',
  styleUrls: [],
  providers: [SidebarService]
})
@Injectable()
export class DocumentViewUsersComponent extends BaseComponent {

  public document: {
    name: string,
    created_by_user: any,
    created_at: string,
    userCount: number,
    user_count: number,
    users_with_attributes: any,
  };
  public dataLoaded = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public documentService: DocumentService,
    public sidebarService: SidebarService,
    public state: State,
    public router: Router
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      sidebarService,
      state,
      router,
      modelService: documentService
    });
    this.setPageVars({
      sidebar: ''
    });
    this.modelServiceGetOne(this.routeParams['id'], 'document').then(() => {
      this.dataLoaded = true;
    });
  }

  public closeSlideout() {
    this.state.message({ slideoutHide: true });
  }
}
